var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCoding(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 1281.565,
    height: 420.926,
    viewBox: "0 0 1281.565 420.926",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ed722f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.269,
    stopColor: "#ed8225"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#ed9718"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ee9f14"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1",
    "data-name": "Group 1",
    transform: "translate(-70.326 -835.482)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "CODING",
    transform: "translate(478.891 991.482)",
    fill: "#fff",
    fontSize: 202.962,
    fontFamily: "Helvetica",
    letterSpacing: "0.06em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "CODING")), /*#__PURE__*/React.createElement("text", {
    id: "NINJAS",
    transform: "translate(479.527 1206.408)",
    fill: "#fff",
    fontSize: 217.772,
    fontFamily: "Helvetica",
    letterSpacing: "0.08em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "NINJAS")), /*#__PURE__*/React.createElement("path", {
    id: "Path_1",
    "data-name": "Path 1",
    d: "M221.727,941.188H415.412V850.142H222.037a150.805,150.805,0,0,0-88.062,22.7A128.121,128.121,0,0,0,84.95,935.481c-9.987,29.96-15.434,60.827-14.526,91.7-.908,30.867,4.539,62.642,14.526,91.694a128.117,128.117,0,0,0,49.025,62.642,150.8,150.8,0,0,0,88.062,22.7H415.412V1103.047H221.727c-24.552,0-41.829-7.275-52.741-20.914s-17.277-33.645-17.277-60.016c0-53.649,22.733-80.929,70.018-80.929Z",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    "data-name": "Path 2",
    d: "M187.9,1008l90.79,17.345S212.1,1094.554,187.9,1008Z",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    "data-name": "Path 3",
    d: "M400.8,1008.309l-88.016,18.263S389.012,1095.051,400.8,1008.309Z",
    fill: "#fff",
    fillRule: "evenodd"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoding);
export default __webpack_public_path__ + "static/media/Coding.cd1bf113b9058f7ddc44ad6e3d5bc2f3.svg";
export { ForwardRef as ReactComponent };